import dayjs from 'dayjs';
import { commonDateFormat, isBeforeCurrentDate } from './DateUtils';
import { pickupDateOffset, dropDateOffset } from '../Constants/Constants';
import { isEmptyObject } from './Basic';

export const createNatNalSearchPayload = (
  nextAvailableLocation: any,
  nextAvailableTime: string,
  appConfigData: any,
) => {
  const convertedNextAvailableTime = commonDateFormat(nextAvailableTime, true, false, '') || '';

  return {
    originLocation: {
      City: nextAvailableLocation?.city,
      State: nextAvailableLocation?.state,
      Country: nextAvailableLocation?.country,
      Zip: nextAvailableLocation?.postalCode,
    },
    destinationLocation: {},
    originRadius: appConfigData?.ORIGIN_RADIUS_INIT?.initialValue,
    destinationRadius: appConfigData?.DESTINATION_RADIUS_INIT?.initialValue,
    originFromDate: commonDateFormat(
      isBeforeCurrentDate(convertedNextAvailableTime) ? dayjs() : convertedNextAvailableTime,
      false,
      false,
      '',
    ) as string,
    originToDate: commonDateFormat(
      convertedNextAvailableTime && !isBeforeCurrentDate(convertedNextAvailableTime)
        ? dayjs(convertedNextAvailableTime).add(pickupDateOffset, 'day')
        : dayjs().add(pickupDateOffset, 'day'),
      false,
      false,
      '',
    ) as string,
    destinationFromDate: commonDateFormat(
      isBeforeCurrentDate(convertedNextAvailableTime) ? dayjs() : convertedNextAvailableTime,
      false,
      false,
      '',
    ) as string,
    destinationToDate: commonDateFormat(
      convertedNextAvailableTime && !isBeforeCurrentDate(convertedNextAvailableTime)
        ? dayjs(convertedNextAvailableTime).add(dropDateOffset, 'day')
        : dayjs().add(dropDateOffset, 'day'),
      false,
      false,
      '',
    ) as string,
  };
};

export const isB2BUser = (memberAzureTenantInfo: any): boolean =>
  memberAzureTenantInfo &&
  !isEmptyObject(memberAzureTenantInfo) &&
  memberAzureTenantInfo?.tenantType === 'B2B';

export const isB2CUser = (memberAzureTenantInfo: any): boolean =>
  memberAzureTenantInfo &&
  !isEmptyObject(memberAzureTenantInfo) &&
  memberAzureTenantInfo?.tenantType === 'B2C';
